import React from 'react'
import { connect } from 'react-redux'
import { Row, Col, Table, Button } from 'react-bootstrap'

import { addAdditionalAntimicrobial } from '../reducers/antibioticsUseFormReducer'


import Antimicrobial from './Antimicrobial'


const AdditionalAntimicrobials = (props) => {
  return (
    <Row>
      <Col xs={12} sm={12} md={12} lg={12}>
        <Table striped bordered responsive>
          <thead>
            <tr>
              {props.chartForReview ?
                null
                :
                <th></th>
                }
              <th>
                Name of oral or IV antimicrobial used for ≥2 days starting any time from 14 days of starting cefiderocol up until 3 days after the last dose of cefiderocol
              </th>

              <th>
                Initiation Date
              </th>

              <th>
                End Date
              </th>
            </tr>
          </thead>

          <tbody>
            {props.additionalAntimicrobials.map(antimicrobial => {
              return (
                <Antimicrobial
                  key={antimicrobial.id}
                  chartForReview={props.chartForReview}
                  {...antimicrobial}
                />
              )
            })}
          </tbody>
        </Table>

        {props.chartForReview ?
          null
          :
          <>
            <br/>
            <Button
              onClick={() => {
                props.addAdditionalAntimicrobial(props.additionalAntimicrobials.length + 1)
              }}
            >
              Add Additional Antimicrobial
            </Button>
          </>
          }
      </Col>
    </Row>
  )
}

const mapStateToProps = (state) => {
  return {
    additionalAntimicrobials: state.antibioticsUseFormReducer.additionalAntimicrobials,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addAdditionalAntimicrobial: (number) => dispatch(addAdditionalAntimicrobial(number)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalAntimicrobials)
